import React, { useState, useEffect } from 'react';
import bgImage from '../assets/bgimagefinal.png';
import logo from '../assets/logo-white.png';
import '../styles/test.css';

function Test({ showCountdown }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const launchDate = new Date('2025-06-01T00:00:00');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = launchDate - now;

      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      return { days, hours, minutes, seconds };
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const { days, hours, minutes, seconds } = timeLeft;

  return (
    <div className="countdown-container" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="overlay"></div>

      <header className="header">
        <img
          src={logo}
          alt="Nutrify Today Logo"
          
          onError={(e) => {
            e.target.src = '';
          }}
        />
      </header>

      <main className="main">
        <h1 className="heading">Dealsphere Launching Soon!</h1>

        {showCountdown && (
          <>
            {days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? (
              <p className="live-message">We are live!</p>
            ) : (
              <div className="timer-grid">
                <div className="timer-box">
                  <span className="timer-value">{days}</span>
                  <p className="timer-label">Days</p>
                </div>
                <div className="timer-box">
                  <span className="timer-value">{hours}</span>
                  <p className="timer-label">Hours</p>
                </div>
                <div className="timer-box">
                  <span className="timer-value">{minutes}</span>
                  <p className="timer-label">Minutes</p>
                </div>
                <div className="timer-box">
                  <span className="timer-value">{seconds}</span>
                  <p className="timer-label">Seconds</p>
                </div>               
              </div>              
            )}
             <div>
                <p className="contact-text">
          Write your interest:{' '}
          <a href="mailto:wow@nutrifytoday.com" className="contact-link">
            wow@nutrifytoday.com
          </a>
        </p>
        <p className="contact-text">
          Or WhatsApp at:{' '}
          <a
            href="https://wa.me/+919538011662"
            className="contact-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            +919538011662
          </a>
        </p>
        </div>
          </>
        )}
      </main>

     
    </div>
  );
}

export default Test;